import type { SVGProps } from 'react';
const SvgCar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <path
      d="m14 6.1-1.133-2.527A1.5 1.5 0 0 0 11.46 2.6H4.539a1.5 1.5 0 0 0-1.406.973L2 6.1m0 5.5v.515c0 .394.158.772.44 1.05a1.51 1.51 0 0 0 2.12 0c.282-.278.44-.656.44-1.05V11.6m6-.258v.774c0 .393.158.77.44 1.049a1.51 1.51 0 0 0 2.12 0c.282-.278.44-.656.44-1.05v-.773M2.244 6.25h11.512c.33 0 .646.15.88.416.233.267.364.629.364 1.006v2.667c0 .188-.066.369-.182.502a.59.59 0 0 1-.44.209H1.622a.59.59 0 0 1-.44-.209A.77.77 0 0 1 1 10.34V7.672c0-.377.131-.74.364-1.006.234-.267.55-.416.88-.416"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
    />
  </svg>
);
export default SvgCar;
